import Vue from 'vue';
import productGroupTransformer from './../../transformers/productGroup';

const success = (resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(productGroupTransformer.fetch(errors));
};

export default productGroup => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('product_groups', productGroup)
      .then(() => {
        success(resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/product-group/store.js